import React, { useEffect } from 'react';
import MainContainer from '../components/layout/MainContainer';
import CreateMoldOrder from '../components/CreateMoldOrder';
import Skeleton from '../components/CreateMoldOrder/Skeleton';
import { useMolds } from '../hooks/useMolds';
import ErrorPage from '../components/pages/Error';

interface CreateMoldOrderContainerProps {}

const CreateMoldOrderContainer: React.FC<CreateMoldOrderContainerProps> = () => {
  const { molds, loading, error, fetchMoldsWithMoldOrder } = useMolds();

  useEffect(() => {
    fetchMoldsWithMoldOrder();
  }, []);

  if (loading)
    return (
      <MainContainer>
        <Skeleton />
      </MainContainer>
    );
  if (error) return <ErrorPage />;

  return (<CreateMoldOrder molds={molds} />);
};

export default CreateMoldOrderContainer;
